<template>
  <div class="login" v-loading="loading">
    <h2 class="login__title">{{ $t("login.title")  }}</h2>
    <p class="login__subtitle">{{ $t("login.sign-in-to-your-account") }}</p>
    <div else class="sign-in login__form-container">
      <el-form ref="form" :model="form" class="login__form" size="medium">
        <el-form-item :label="$t('login.email')" class="login__form-item">
          <el-input v-model="form.email" @keyup.native.enter="doLogin"></el-input>
        </el-form-item>
        <el-form-item :label="$t('login.password')" class="login__form-item">
          <el-input v-model="form.password" show-password @keyup.native.enter="doLogin"></el-input>
        </el-form-item>
      </el-form>
      <el-button type="primary" class="button login__form-send-button" @click="doLogin" :disabled="!recaptchaIsValid">{{ $t("login.login") }}</el-button>
      <p v-show="errorMessage" class="text-center error-message">{{ errorMessage }}</p>
      <div class="text-center login__form-forgot-password-container">
        <router-link :to="{ name: 'ForgotPassword' }">{{ $t("recover-password.you-forgot-the-password") }}</router-link>
      </div>
      <p class="or text-center">{{ $t("common.or") }}</p>
      <el-button class="button login__form-tenant-button" @click="$router.push({ name : 'LoginAsTenant'})" >{{ $t("login.login-as-company") }}</el-button>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import http from "@/api/http";
import { mapActions } from "vuex";
import { VueReCaptcha } from "vue-recaptcha-v3";
import * as firebase from 'firebase/app'
export default {
  data() {
    return {
      form: {
        email: "",
        password: "",
        token: ""
      },
      loading: false,
      errorMessage: "",
      recaptchaIsValid: false,
      recaptchaToken: "",
    }
  },
  methods: {
    ...mapActions(["login"]),
    async doLogin() {
      this.loading = true;
      this.errorMessage = '';
      try {
        await this.validateRecaptcha();
        await http.post('/recaptcha', { token: this.form.token });
        await this.$store.dispatch("login", this.form);
        const { user } = await firebase.auth().signInWithEmailAndPassword(this.form.email, this.form.password)
        const idToken = await user.getIdToken();
        await this.$store.dispatch('verifyToken', idToken)
        await this.$store.commit("SET_USER_EMAIL", user.email);
        if(this.$route.query && 'mode' in this.$route.query){
          window.location.href = "/softphone-widget"
          return
        }
        window.location.href = "/home"
      } catch (error) {
        this.loading = false;
        this.errorMessage = error.response ? error.response.data.message : error.message;
      }
    },
    async validateRecaptcha() {
      await this.$recaptchaLoaded();
      this.form.token = await this.$recaptcha('login')
      this.recaptchaIsValid = true;
    }
  },
  created() {
    Vue.use(VueReCaptcha, {
      siteKey: process.env.VUE_APP_RECAPTCHA_SITE_KEY
    });
    this.validateRecaptcha();
    firebase.auth().tenantId = null
  }
}
</script>
<style>
@media screen and (max-height: 500px) {

  .login .login__form-container .login__form-item label{
    line-height: 20px !important;
    font-size: 13px !important;

  }


  .login .el-form-item{
    margin-bottom: 10px !important;
  }

  .login .el-input__inner{
    height: 30px !important;
  }

}
</style>
<style scoped>

.or {
  display: inline-flex;
  width: 100%;
  align-items: center;
}
.or::before,
.or::after {
  content: "";
  display: block;
  width: 100%;
  height: 1px;
  background: #dcdfe6;
}

.or::before {
  margin-right: var(--column)
}

.or::after {
  margin-left: var(--column)
}

.button {
  width: 100%;
}

.text-center {
  text-align: center;
}

.error-message {
  color: var(--red);
}

.sign-in {
  display: flex; 
  flex-direction: column;
  gap: var(--column)
}

@media screen and (max-height: 500px) {
  .login__subtitle{
    display: none;
  }
  .login__title{
    font-size: 15px;
    text-align: center;
  }
  .login {
    font-size: 13px;
  }

  .login .login__form-send-button{
    font-size: 13px !important;
    padding: 10px !important;
  }
  .login__form-tenant-button{
    font-size: 13px !important;
    padding: 10px !important;
  }
}
</style>